
import styles from './kickstarter.module.css';

export default function Kickstarter() {

  document.title = `Bob Flanagan Kickstarter Thank You | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', ``);


  return (
    <div className='newPageContainer'>

      <div className={styles.kickstarterPage}>
        <p>A very special note of gratitude to all those who supported the production of the expanded <em>Fuck Journal</em> edition through our Kickstarter campaign.</p>
        <div>
          <p>
            <strong>Digital Supporters</strong>
            <br />
            Rebecca Burden
            <br />
            Sophie Penrose
            <br />
            Liza Berdnick
          </p>

          <p>
            Artist books and artist literature are at the core of the Hanuman Editions project and it has been very special to share in this endeavor with our community of friends and readers across the world: from Australia to Denmark, the UK, the US, Canada, Germany, Ireland, Serbia, Croatia and Greece! Thank you!

          </p>
        </div>
      </div>
    </div>
  )
}